import { useTranslation } from 'react-i18next';
import { DocumentTagTechLibrary } from '@customer/store/apis/documentsApi';
import Page from '@customer/templates/page/Page';
import { FilterGroup } from '@customer/filters/types';
import { QueryTag } from '@customer/store/api';
import useTechLibrary from './useTechLibrary';
import CardTable from '@customer/components/tables/card-table/CardTable';
import { GridControlled } from '@customer/components/tables/grid/GridControlled';
import PageHeader from '@customer/components/layout/page-header/PageHeader';
import { TechLibraryDocumentModel } from '@cas/config/documents';
import { TagDescription } from '@reduxjs/toolkit/query';

const SLICE_KEY_TECH_LIBRARY = 'TechnicalLibrary';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Document, id: DocumentTagTechLibrary },
];

export function TechLibrary() {
  const { t } = useTranslation();

  const { columns, data, hasData, noDataDescription, noResultsDescription, onRowClick } =
    useTechLibrary('NoDocsAvailable');

  return (
    <Page
      header={
        <PageHeader
          title={t('TechnicalLibrary')}
          sliceKey={SLICE_KEY_TECH_LIBRARY}
          tagsToClearOnRefresh={tagsToClearOnRefresh}
          filterProps={{
            filterGroup: FilterGroup.TechLibrary,
            countAll: data?.countAll,
            countFilter: data?.countFilter,
            transKey: 'ShowingDocs',
            filteredTransKey: 'ShowingFilteredDocs',
          }}
        />
      }
    >
      <CardTable hasData={hasData} noDataDescription={noDataDescription}>
        <GridControlled<TechLibraryDocumentModel>
          sliceKey={SLICE_KEY_TECH_LIBRARY}
          rowData={data?.items}
          columnDefs={columns}
          noRowsMessage={noResultsDescription}
          onRowClick={onRowClick}
          includeHiddenColumnsInQuickFilter={true}
        />
      </CardTable>
    </Page>
  );
}

export default TechLibrary;
